<template>
  <a-card :bordered="false">
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row>
          <a-col :span="12">
            <a-form-item label="仓库">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="warehouseLoading ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'warehouse_id',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请输入仓库"
                @search="this.warehouseSearch"
                @change="handleWarehouseChange"
              >
                <a-spin v-if="warehouseLoading" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in warehouseList" :key="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="提货单毛量">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['gross_weight', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="提货单毛量"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="提货单净量">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['net_weight', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="提货单净量"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="过磅量">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['weighing_capacity', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="过磅量"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="实收数量">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['real_weight', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="实收数量"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="单位" >
              <a-select
                v-decorator="[
                  'unit',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.unit">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="预估人民币价格">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['unit_price_cny', {rules: [{required: false, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="出入库时间">
              <a-date-picker
                v-decorator="['in_out_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="请选择"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="报关日期">
              <a-date-picker
                v-decorator="['declaration_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="报关日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
            <a-tooltip title="报关日期：外贸业务为报关单申报日期；内贸业务为进项发票取得日期">
              <a-icon type="info-circle" theme="filled" style="padding-left: 8px"/>
            </a-tooltip>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item v-bind="buttonCol">
              <a-row>
                <a-col offset="6" span="8">
                  <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
                </a-col>
                <a-col span="10">
                  <a-button @click="handleGoBack">返回</a-button>
                </a-col>
              </a-row>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-card>
</template>

<script>
// import moment from 'moment'
import pick from 'lodash.pick'
import { inventory_adjustment_update, inventory_adjustment_list } from '@/api/trade_inventory_adjustment'
import { warehouse_list } from '@/api/trade_warehouse'
import debounce from 'lodash/debounce'

export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    this.warehouseSearch = debounce(this.filterWarehouseSearch, 800)
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      unit: this.$Dictionaries.unit,
      warehouseList: [],
      loading: false,
      warehouseId: undefined,
      warehouseLoading: false,
      id: 0,
      data: {}
    }
  },
  mounted () {
    this.loadData()
    this.warehouseId = this.$route.query.warehouse_id
    this.handleWarehouseSearch(undefined)
  },
  methods: {
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    loadData () {
      this.loading = true
      inventory_adjustment_list({ id: this.$route.params.adjustment_id })
        .then(res => {
          console.log(res.data, '我是数据列表@')
          const list = res.data.entries
          if (list && list.length > 0) {
            this.data = list[0]
            this.id = this.data.id
            this.loadEditInfo(this.data)
            this.handleWarehouseSearch(undefined)
          }
        }).finally(() => {
          this.loading = false
      })
    },
    filterWarehouseSearch (value) {
      this.warehouseId = undefined
      this.warehouseLoading = true
      this.handleWarehouseSearch(value)
    },
    handleWarehouseSearch (value) {
      warehouse_list({ name: value, id: this.warehouseId, page: 1, pageSize: 999 }).then((res) => {
        const result = res.data.entries || []
        this.warehouseList = result
      }).finally(() => {
        this.warehouseLoading = false
      })
    },
    handleWarehouseChange (value) {
      console.log(value)
      this.warehouseId = value
      if (value === undefined) {
        this.handleWarehouseSearch(value)
      }
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          // eslint-disable-next-line no-console
          console.log('Received values of form: ', values)
          if (values['gross_weight'] === null) {
            values['gross_weight'] = 0
          }
          if (values['net_weight'] === null) {
            values['net_weight'] = 0
          }
          if (values['weighing_capacity'] === null) {
            values['weighing_capacity'] = 0
          }
          if (values['real_weight'] === null) {
            values['real_weight'] = 0
          }
          if (values['unit_price_cny'] === null) {
            values['unit_price_cny'] = 0
          }
          inventory_adjustment_update(values, this.id)
            .then((res) => {
              this.handleGoBack()
              console.log(res, '修改成功')
            })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, ['warehouse_id', 'gross_weight', 'net_weight', 'weighing_capacity', 'real_weight', 'unit', 'unit_price_cny', 'in_out_date', 'declaration_date'])
        console.log('formData', formData)
        form.setFieldsValue(formData)
      })
    }
  }
}
</script>
